import { Box, Drawer, Grid, Typography } from '@mui/material';
import CustomTextField from '../../../../../components/customized/customtextfield/CustomTextField';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import CustomButton from '../../../../../components/buttons/CustomButton';
import CustomSelect from '../../../../../components/customized/customselect/CustomSelect';
import { useAppDispatch, useAppSelector } from '../../../../../../app/redux/hooks';
import { updateYaantracVehicle } from '../../../../../../features/yaantrac/redux/reducer/yaantracSlices/overSpeedSlice';
import { useEffect } from 'react';

const autoplannerSchema: any = yup.object().shape({
  seatingCapacity: yup
    .number()
    .typeError('Seating Capacity must be a number')
    .required('Enter the Seating Capacity'),
  surveillance: yup
    .string()
    .trim()
    .typeError('Surveillance must be a string')
    .required('Select Surveillance'),
  wifi: yup.string().trim().typeError('Wifi must be a string').required('Select Wifi'),
  wheelChair: yup
    .string()
    .trim()
    .typeError('Wheel Chair must be a string')
    .required('Select Wheel Chair'),
  ac: yup.string().trim().typeError('AC must be a string').required('Select AC')
});

interface UpdateAutoplanner {
  open: boolean;
  setOpen: any;
  roleType: string;
  filteredRow: any;
}
interface TextField {
  id: string;
  label: string;
  field: 'seatingCapacity' | 'surveillance' | 'wifi' | 'wheelChair' | 'ac';
  placeholder: string;
  inputProps: {
    maxLength?: number;
    style?: React.CSSProperties;
  };
  options?: { id: string; label: string }[];
}

const UpdateAutoplanner = ({
  open,
  setOpen,
  roleType,
  filteredRow
}: UpdateAutoplanner) => {
  const dispatch = useAppDispatch();
  const { isLoading } = useAppSelector(state => state.updateYaantrac);

  const { control, handleSubmit, setValue, reset } = useForm({
    resolver: yupResolver(autoplannerSchema)
  });

  const textField: TextField[] = [
    {
      id: '1',
      label: 'Seating Capacity',
      field: 'seatingCapacity',
      placeholder: 'Seating Capacity',
      inputProps: { maxLength: 40 }
    },
    {
      id: '2',
      label: 'Surveillance',
      field: 'surveillance',
      placeholder: 'Surveillance',
      inputProps: { maxLength: 40 },
      options: [
        { id: 'true', label: 'Available' },
        { id: 'false', label: 'Not Available' }
      ]
    },
    {
      id: '3',
      label: 'Wifi',
      field: 'wifi',
      placeholder: 'Wifi',
      inputProps: { maxLength: 10 },
      options: [
        { id: 'true', label: 'Available' },
        { id: 'false', label: 'Not Available' }
      ]
    },
    {
      id: '4',
      label: 'Wheel Chair',
      field: 'wheelChair',
      placeholder: 'Wheel Chair',
      inputProps: { maxLength: 10 },
      options: [
        { id: 'true', label: 'Available' },
        { id: 'false', label: 'Not Available' }
      ]
    },
    {
      id: '5',
      label: 'AC',
      field: 'ac',
      placeholder: 'AC',
      inputProps: { maxLength: 10 },
      options: [
        { id: 'true', label: 'Available' },
        { id: 'false', label: 'Not Available' }
      ]
    }
  ];

  const onSubmit = async (data: any) => {
    if (filteredRow) {
      let updatePayload: any = {
        freewaySpeedLimit: filteredRow?.row?.freewaySpeedLimit,
        nonFreewaySpeedLimit: filteredRow?.row?.nonFreewaySpeedLimit,
        lastServicedDate: filteredRow?.row?.lastServicedDate,
        dotInspectionDate: filteredRow?.row?.dotInspectionDate,
        insuranceExpiryDate: filteredRow?.row?.insuranceExpiryDate,
        vehicleNumber: filteredRow?.row?.vehicleNumber,
        vehicleCategory: filteredRow?.row?.vehicleCategory,
        fuelType: filteredRow?.row?.fuelType,
        vehicleMake: filteredRow?.row?.vehicleMake,
        vehicleType: filteredRow?.row?.vehicleType,
        fuelCapacity: filteredRow?.row?.fuelCapacity,
        vehicleColor: filteredRow?.row?.vehicleColor,
        vehicleModel: filteredRow?.row?.vehicleModel,
        vehicleEngineNumber: filteredRow?.row?.vehicleEngineNumber,
        vehicleChassisNumber: filteredRow?.row?.vehicleChassisNumber,
        vehicleExpirationDate: filteredRow?.row?.vehicleExpirationDate,
        vehicleRegistrationDate: filteredRow?.row?.vehicleRegistrationDate,
        isAc: data.ac,
        isSurveillanceAvailable: data.surveillance,
        isWheelchairAccessible: data.wheelChair,
        isWifiAvailable: data.wifi,
        seatingCapacity: data.seatingCapacity
      };
      let payload: { updatePayload: any; id: any } = {
        updatePayload: updatePayload,
        id: filteredRow.id
      };
      await dispatch(updateYaantracVehicle({ data: payload, category: 'tourism' }));
      setOpen(false);
    }
  };

  const handleClose = () => {
    reset();
    setOpen(false);
  };

  useEffect(() => {
    setValue('seatingCapacity', filteredRow?.row?.seatingCapacity);
    setValue('surveillance', filteredRow?.row?.isSurveillanceAvailable);
    setValue('wifi', filteredRow?.row?.isWifiAvailable);
    setValue('wheelChair', filteredRow?.row?.isWheelchairAccessible);
    setValue('ac', filteredRow?.row?.isAc);
  }, [filteredRow]);

  return (
    <>
      <Box p={2}>
        <Drawer
          anchor='right'
          open={open}
          onClose={() => {
            setOpen(false);
            reset();
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '15px !important'
            }}
          >
            <Typography sx={{ fontWeight: 700 }}>{roleType}</Typography>
            <Box
              sx={{ display: 'flex', flexDirection: 'column', gap: 15 }}
              className='autoplanner-container'
            >
              <Box component={'form'} onSubmit={handleSubmit(onSubmit)}>
                <Grid container spacing={1}>
                  {textField?.map(item => (
                    <Grid item key={item.id} xs={12} className='yaantrac-item'>
                      {item?.options ? (
                        <CustomSelect
                          control={control}
                          name={item.field}
                          placeholder={item.placeholder}
                          id={item.id}
                          label={item.label}
                          options={item.options}
                        />
                      ) : (
                        <CustomTextField
                          control={control}
                          name={item.field}
                          placeholder={item.placeholder}
                          id={item.id}
                          label={item.label}
                          inputProps={item.inputProps}
                        />
                      )}
                    </Grid>
                  ))}
                </Grid>
                <Box sx={{ marginTop: '5%', display: 'flex', gap: '15px' }}>
                  <CustomButton
                    className='saveChanges'
                    type='submit'
                    category={roleType}
                    loading={isLoading}
                  />
                  <CustomButton
                    className='cancel'
                    category='Cancel'
                    onClick={() => {
                      handleClose();
                    }}
                  />
                </Box>
              </Box>
            </Box>
          </Box>
        </Drawer>
      </Box>
    </>
  );
};

export default UpdateAutoplanner;
